module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "olst-field-modal"
  }, [_c('span', {
    staticClass: "modal-open",
    attrs: {
      "name": _vm.name + 'Button'
    },
    on: {
      "click": _vm.toggle
    }
  }), _c('div', {
    staticClass: "modal-parent",
    attrs: {
      "id": _vm.name + '-modal'
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade-mask"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "modal-mask",
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('transition', {
    attrs: {
      "name": "slide-modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "modal-close",
    on: {
      "click": function($event) {
        _vm.toggle()
      }
    }
  })]), _c('div', {
    staticClass: "modal-content",
    domProps: {
      "innerHTML": _vm._s(_vm.tooltip)
    }
  })])])], 1)])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-74b36175!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@oliverstore/core-rendering-engine/src/views/components/tooltip/ModalWithButton.vue
// module id = 362
// module chunks = 1